/**
 * Archivo de íconos SVG reutilizables
 *
 * Contiene una colección de componentes de íconos SVG personalizados para usar en la aplicación.
 *
 * @example
 * import { DeleteSVGIcon } from './Icons';
 *
 * <DeleteSVGIcon colorFill="#E63D3D" />
 */
/**
 * Archivo de íconos SVG reutilizables
 *
 * Contiene una colección de componentes de íconos SVG personalizados para usar en la aplicación.
 *
 * @example
 * import { DeleteSVGIcon } from './Icons';
 *
 * <DeleteSVGIcon colorFill="#E63D3D" />
 */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-multi-comp */
import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function DeleteSVGIcon({
  colorFill = '#E63D3D',
  isDisabled = false,
  ...props
}) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 24 25"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 21.75C6.45 21.75 5.97917 21.5542 5.5875 21.1625C5.19583 20.7708 5 20.3 5 19.75V6.75H4V4.75H9V3.75H15V4.75H20V6.75H19V19.75C19 20.3 18.8042 20.7708 18.4125 21.1625C18.0208 21.5542 17.55 21.75 17 21.75H7ZM9 17.75H11V8.75H9V17.75ZM13 17.75H15V8.75H13V17.75Z"
          fill={colorFill}
          fillOpacity={isDisabled ? 0.5 : 1}
        />
      </svg>
    </SvgIcon>
  );
}

export function IndividualMapSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5156 22.6846C11.1323 22.6846 9.83229 22.4221 8.61562 21.8971C7.39896 21.3721 6.34063 20.6596 5.44062 19.7596C4.54063 18.8596 3.82812 17.8012 3.30313 16.5846C2.77813 15.3679 2.51562 14.0679 2.51562 12.6846C2.51562 11.3012 2.77813 10.0012 3.30313 8.78457C3.82812 7.5679 4.54063 6.50957 5.44062 5.60957C6.34063 4.70957 7.39896 3.99707 8.61562 3.47207C9.83229 2.94707 11.1323 2.68457 12.5156 2.68457C13.899 2.68457 15.199 2.94707 16.4156 3.47207C17.6323 3.99707 18.6906 4.70957 19.5906 5.60957C20.4906 6.50957 21.2031 7.5679 21.7281 8.78457C22.2531 10.0012 22.5156 11.3012 22.5156 12.6846C22.5156 14.0679 22.2531 15.3679 21.7281 16.5846C21.2031 17.8012 20.4906 18.8596 19.5906 19.7596C18.6906 20.6596 17.6323 21.3721 16.4156 21.8971C15.199 22.4221 13.899 22.6846 12.5156 22.6846ZM11.5156 20.6346V18.6846C10.9656 18.6846 10.4948 18.4887 10.1031 18.0971C9.71146 17.7054 9.51562 17.2346 9.51562 16.6846V15.6846L4.71563 10.8846C4.66563 11.1846 4.61979 11.4846 4.57812 11.7846C4.53646 12.0846 4.51562 12.3846 4.51562 12.6846C4.51562 14.7012 5.17813 16.4679 6.50312 17.9846C7.82812 19.5012 9.49896 20.3846 11.5156 20.6346ZM18.4156 18.0846C18.749 17.7179 19.049 17.3221 19.3156 16.8971C19.5823 16.4721 19.8031 16.0304 19.9781 15.5721C20.1531 15.1137 20.2865 14.6429 20.3781 14.1596C20.4698 13.6762 20.5156 13.1846 20.5156 12.6846C20.5156 11.0512 20.0615 9.55957 19.1531 8.20957C18.2448 6.85957 17.0323 5.88457 15.5156 5.28457V5.68457C15.5156 6.23457 15.3198 6.7054 14.9281 7.09707C14.5365 7.48874 14.0656 7.68457 13.5156 7.68457H11.5156V9.68457C11.5156 9.9679 11.4198 10.2054 11.2281 10.3971C11.0365 10.5887 10.799 10.6846 10.5156 10.6846H8.51562V12.6846H14.5156C14.799 12.6846 15.0365 12.7804 15.2281 12.9721C15.4198 13.1637 15.5156 13.4012 15.5156 13.6846V16.6846H16.5156C16.949 16.6846 17.3406 16.8137 17.6906 17.0721C18.0406 17.3304 18.2823 17.6679 18.4156 18.0846Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function LogbookSVG({ color = '#3352C1', ...props }) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.51562 18.6846H16.5156V16.6846H8.51562V18.6846ZM8.51562 14.6846H16.5156V12.6846H8.51562V14.6846ZM6.51562 22.6846C5.96563 22.6846 5.49479 22.4887 5.10313 22.0971C4.71146 21.7054 4.51562 21.2346 4.51562 20.6846V4.68457C4.51562 4.13457 4.71146 3.66374 5.10313 3.27207C5.49479 2.8804 5.96563 2.68457 6.51562 2.68457H14.5156L20.5156 8.68457V20.6846C20.5156 21.2346 20.3198 21.7054 19.9281 22.0971C19.5365 22.4887 19.0656 22.6846 18.5156 22.6846H6.51562ZM13.5156 9.68457H18.5156L13.5156 4.68457V9.68457Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
}

export function LocationRelatedServicesSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.51562 23.6846C3.96563 23.6846 3.49479 23.4887 3.10313 23.0971C2.71146 22.7054 2.51562 22.2346 2.51562 21.6846V7.68457H4.51562V21.6846H15.5156V23.6846H4.51562ZM8.51562 19.6846C7.96563 19.6846 7.49479 19.4887 7.10313 19.0971C6.71146 18.7054 6.51562 18.2346 6.51562 17.6846V3.68457C6.51562 3.13457 6.71146 2.66374 7.10313 2.27207C7.49479 1.8804 7.96563 1.68457 8.51562 1.68457H15.5156L21.5156 7.68457V17.6846C21.5156 18.2346 21.3198 18.7054 20.9281 19.0971C20.5365 19.4887 20.0656 19.6846 19.5156 19.6846H8.51562ZM14.5156 8.68457H19.5156L14.5156 3.68457V8.68457Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ITAssetManagementSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5156 22.6845C9.83229 20.4011 7.82812 18.2803 6.50313 16.322C5.17813 14.3636 4.51562 12.5511 4.51562 10.8845C4.51562 8.38447 5.31979 6.39281 6.92813 4.90947C8.53646 3.42614 10.399 2.68447 12.5156 2.68447C12.9656 2.68447 13.4115 2.72197 13.8531 2.79697C14.2948 2.87197 14.724 2.97614 15.1406 3.10947L9.51562 8.75947V13.6845H14.4406L20.0656 8.05947C20.2156 8.49281 20.3281 8.94281 20.4031 9.40947C20.4781 9.87614 20.5156 10.3678 20.5156 10.8845C20.5156 12.5511 19.8531 14.3636 18.5281 16.322C17.2031 18.2803 15.199 20.4011 12.5156 22.6845ZM11.5156 11.6845V9.58447L17.7156 3.38447L19.8156 5.48447L13.6156 11.6845H11.5156ZM20.5156 4.78447L18.4156 2.68447L19.1156 1.98447C19.299 1.80114 19.5323 1.70947 19.8156 1.70947C20.099 1.70947 20.3323 1.80114 20.5156 1.98447L21.2156 2.68447C21.399 2.86781 21.4906 3.10114 21.4906 3.38447C21.4906 3.66781 21.399 3.90114 21.2156 4.08447L20.5156 4.78447Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function AttentionStateSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4457 5.25C15.1647 5.25 14.9284 5.15299 14.7367 4.95898C14.5451 4.76496 14.4492 4.52746 14.4492 4.24647C14.4492 3.96549 14.5462 3.72917 14.7402 3.5375C14.9343 3.34583 15.1718 3.25 15.4527 3.25C15.7337 3.25 15.9701 3.34701 16.1617 3.54103C16.3534 3.73504 16.4492 3.97254 16.4492 4.25353C16.4492 4.53451 16.3522 4.77083 16.1582 4.9625C15.9642 5.15417 15.7267 5.25 15.4457 5.25ZM15.4457 21.75C15.1647 21.75 14.9284 21.653 14.7367 21.459C14.5451 21.265 14.4492 21.0275 14.4492 20.7465C14.4492 20.4655 14.5462 20.2292 14.7402 20.0375C14.9343 19.8458 15.1718 19.75 15.4527 19.75C15.7337 19.75 15.9701 19.847 16.1617 20.041C16.3534 20.235 16.4492 20.4725 16.4492 20.7535C16.4492 21.0345 16.3522 21.2708 16.1582 21.4625C15.9642 21.6542 15.7267 21.75 15.4457 21.75ZM19.4457 8.75C19.1647 8.75 18.9284 8.65299 18.7367 8.45898C18.5451 8.26496 18.4492 8.02746 18.4492 7.74648C18.4492 7.46549 18.5462 7.22917 18.7402 7.0375C18.9343 6.84583 19.1718 6.75 19.4527 6.75C19.7337 6.75 19.9701 6.84701 20.1617 7.04102C20.3534 7.23504 20.4492 7.47254 20.4492 7.75352C20.4492 8.03451 20.3522 8.27083 20.1582 8.4625C19.9642 8.65417 19.7267 8.75 19.4457 8.75ZM19.4457 18.25C19.1647 18.25 18.9284 18.153 18.7367 17.959C18.5451 17.765 18.4492 17.5275 18.4492 17.2465C18.4492 16.9655 18.5462 16.7292 18.7402 16.5375C18.9343 16.3458 19.1718 16.25 19.4527 16.25C19.7337 16.25 19.9701 16.347 20.1617 16.541C20.3534 16.735 20.4492 16.9725 20.4492 17.2535C20.4492 17.5345 20.3522 17.7708 20.1582 17.9625C19.9642 18.1542 19.7267 18.25 19.4457 18.25ZM20.9457 13.5C20.6647 13.5 20.4284 13.403 20.2367 13.209C20.0451 13.015 19.9492 12.7775 19.9492 12.4965C19.9492 12.2155 20.0462 11.9792 20.2402 11.7875C20.4343 11.5958 20.6718 11.5 20.9527 11.5C21.2337 11.5 21.4701 11.597 21.6617 11.791C21.8534 11.985 21.9492 12.2225 21.9492 12.5035C21.9492 12.7845 21.8522 13.0208 21.6582 13.2125C21.4642 13.4042 21.2267 13.5 20.9457 13.5ZM12.1992 22.5C10.8159 22.5 9.51589 22.2375 8.29922 21.7125C7.08255 21.1875 6.02422 20.475 5.12422 19.575C4.22422 18.675 3.51172 17.6167 2.98672 16.4C2.46172 15.1833 2.19922 13.8833 2.19922 12.5C2.19922 11.1167 2.46172 9.81667 2.98672 8.6C3.51172 7.38333 4.22422 6.325 5.12422 5.425C6.02422 4.525 7.08255 3.8125 8.29922 3.2875C9.51589 2.7625 10.8159 2.5 12.1992 2.5V4C9.83255 4 7.82422 4.82343 6.17422 6.4703C4.52422 8.11718 3.69922 10.1271 3.69922 12.5C3.69922 14.8729 4.52265 16.8828 6.16952 18.5297C7.8164 20.1766 9.8263 21 12.1992 21V22.5ZM12.197 14.25C11.7151 14.25 11.3034 14.0786 10.9617 13.7359C10.6201 13.3932 10.4492 12.9812 10.4492 12.5C10.4492 12.401 10.4576 12.2971 10.4742 12.1883C10.4909 12.0794 10.5159 11.9847 10.5492 11.9043L8.54922 9.9L9.59922 8.85L11.6242 10.85C11.7076 10.8167 11.8992 10.7833 12.1992 10.75C12.6805 10.75 13.0925 10.9216 13.4352 11.2647C13.7779 11.6079 13.9492 12.0204 13.9492 12.5022C13.9492 12.9841 13.7776 13.3958 13.4345 13.7375C13.0914 14.0792 12.6789 14.25 12.197 14.25Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function EnabledServiceTypesSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.8496 12.9685C23.7716 13.3614 23.7313 13.766 23.6098 14.1453C22.8309 16.577 21.1869 18.0604 18.6601 18.4352C15.4373 18.9136 12.478 16.6906 11.9312 13.4618C11.3949 10.2921 13.5611 7.19143 16.7228 6.60546C20.1379 5.97194 23.306 8.25778 23.7989 11.7107C23.8146 11.8219 23.8327 11.9328 23.8496 12.0436V12.9689V12.9685ZM15.2872 12.4974C15.2872 13.92 16.4266 15.0653 17.8469 15.0698C19.268 15.0742 20.432 13.9099 20.4256 12.4905C20.4192 11.08 19.256 9.92017 17.8498 9.92219C16.4395 9.9242 15.2876 11.082 15.2872 12.4974Z"
          fill="#3352C1"
        />
        <path
          d="M11.8428 8.52961C11.1511 9.80141 10.7942 11.1206 10.7974 12.5161C10.8 13.9018 11.1558 15.213 11.8496 16.4839C11.7268 16.49 11.6439 16.4975 11.5615 16.4979C9.8417 16.4984 8.12243 16.5026 6.40264 16.4975C4.17379 16.4904 2.37895 15.1821 1.93602 13.2516C1.39967 10.9134 3.42962 8.58024 6.10193 8.52117C7.98651 8.47945 9.87266 8.51226 11.7583 8.51226C11.7751 8.51226 11.7919 8.5193 11.8438 8.53055L11.8428 8.52961Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServicesSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.35 22.4254C19.225 22.4254 19.1063 22.4025 18.9937 22.3566C18.8813 22.3108 18.7792 22.2421 18.6875 22.1504L13.425 16.8879C13.3333 16.7962 13.2646 16.6941 13.2188 16.5816C13.1729 16.4691 13.15 16.3504 13.15 16.2254C13.15 16.1004 13.1729 15.9816 13.2188 15.8691C13.2646 15.7566 13.3333 15.6546 13.425 15.5629L15.5375 13.4504C15.6292 13.3587 15.7312 13.29 15.8438 13.2441C15.9563 13.1983 16.075 13.1754 16.2 13.1754C16.325 13.1754 16.4438 13.1983 16.5563 13.2441C16.6687 13.29 16.7708 13.3587 16.8625 13.4504L22.125 18.7129C22.2167 18.8046 22.2854 18.9066 22.3313 19.0191C22.3771 19.1316 22.4 19.2504 22.4 19.3754C22.4 19.5004 22.3771 19.6191 22.3313 19.7316C22.2854 19.8441 22.2167 19.9462 22.125 20.0379L20.0125 22.1504C19.9208 22.2421 19.8188 22.3108 19.7063 22.3566C19.5938 22.4025 19.475 22.4254 19.35 22.4254ZM5.625 22.4379C5.5 22.4379 5.37917 22.415 5.2625 22.3691C5.14583 22.3233 5.04167 22.2546 4.95 22.1629L2.8375 20.0504C2.74583 19.9587 2.67708 19.8546 2.63125 19.7379C2.58542 19.6212 2.5625 19.5004 2.5625 19.3754C2.5625 19.2504 2.58542 19.1337 2.63125 19.0254C2.67708 18.9171 2.74583 18.8171 2.8375 18.7254L8.125 13.4379H10.25L11.1625 12.5254L6.975 8.33789H5.55L2.5875 5.37539L5.325 2.63789L8.2875 5.60039V7.02539L12.475 11.2129L15.4625 8.22539L14.3875 7.15039L15.85 5.68789H12.9L12.2625 5.05039L15.725 1.58789L16.3625 2.22539V5.17539L17.825 3.71289L21.325 7.22539C21.6 7.50039 21.8125 7.81289 21.9625 8.16289C22.1125 8.51289 22.1875 8.88372 22.1875 9.27539C22.1875 9.65872 22.1167 10.0254 21.975 10.3754C21.8333 10.7254 21.6333 11.0379 21.375 11.3129L19.25 9.18789L17.85 10.5879L16.8 9.53789L11.5625 14.7754V16.8754L6.275 22.1629C6.18333 22.2546 6.08333 22.3233 5.975 22.3691C5.86667 22.415 5.75 22.4379 5.625 22.4379Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function AddConfigComponetToKitSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5621 22.9371V19.9371H14.5621V18.0621H17.5621V15.0621H19.4371V18.0621H22.4371V19.9371H19.4371V22.9371H17.5621ZM8.57461 16.8371C8.83294 16.8371 9.05378 16.7454 9.23711 16.5621C9.42044 16.3788 9.51211 16.1579 9.51211 15.8996C9.51211 15.6413 9.42044 15.4204 9.23711 15.2371C9.05378 15.0538 8.83294 14.9621 8.57461 14.9621C8.31628 14.9621 8.09544 15.0538 7.91211 15.2371C7.72878 15.4204 7.63711 15.6413 7.63711 15.8996C7.63711 16.1579 7.72878 16.3788 7.91211 16.5621C8.09544 16.7454 8.31628 16.8371 8.57461 16.8371ZM8.57461 12.9371C8.83294 12.9371 9.05378 12.8454 9.23711 12.6621C9.42044 12.4788 9.51211 12.2579 9.51211 11.9996C9.51211 11.7413 9.42044 11.5204 9.23711 11.3371C9.05378 11.1538 8.83294 11.0621 8.57461 11.0621C8.31628 11.0621 8.09544 11.1538 7.91211 11.3371C7.72878 11.5204 7.63711 11.7413 7.63711 11.9996C7.63711 12.2579 7.72878 12.4788 7.91211 12.6621C8.09544 12.8454 8.31628 12.9371 8.57461 12.9371ZM8.57461 9.01211C8.83294 9.01211 9.05378 8.92044 9.23711 8.73711C9.42044 8.55378 9.51211 8.33294 9.51211 8.07461C9.51211 7.81628 9.42044 7.59544 9.23711 7.41211C9.05378 7.22878 8.83294 7.13711 8.57461 7.13711C8.31628 7.13711 8.09544 7.22878 7.91211 7.41211C7.72878 7.59544 7.63711 7.81628 7.63711 8.07461C7.63711 8.33294 7.72878 8.55378 7.91211 8.73711C8.09544 8.92044 8.31628 9.01211 8.57461 9.01211ZM11.5246 12.9246H17.3746V11.0496H11.5246V12.9246ZM11.5246 9.02461H17.3746V7.14961H11.5246V9.02461ZM5.59961 20.7746C5.08398 20.7746 4.64257 20.591 4.27538 20.2238C3.9082 19.8567 3.72461 19.4152 3.72461 18.8996V5.09961C3.72461 4.58398 3.9082 4.14257 4.27538 3.77538C4.64257 3.4082 5.08398 3.22461 5.59961 3.22461H19.3996C19.9152 3.22461 20.3567 3.4082 20.7238 3.77538C21.091 4.14257 21.2746 4.58398 21.2746 5.09961V13.7746C20.8496 13.5496 20.4017 13.3788 19.9309 13.2621C19.46 13.1454 18.9829 13.0871 18.4996 13.0871C17.6406 13.0871 16.8384 13.2559 16.0929 13.5934C15.3474 13.9309 14.7038 14.3913 14.1621 14.9746H11.5246V16.8496H12.9746C12.8496 17.1746 12.7517 17.5059 12.6809 17.8434C12.61 18.1809 12.5704 18.5329 12.5621 18.8996C12.5538 19.2163 12.5708 19.5302 12.6131 19.8413C12.6554 20.1524 12.7259 20.4635 12.8246 20.7746H5.59961Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function NextStepSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 24 25"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 18.6836V6.68359H4V18.6836H2ZM16 18.6836L14.575 17.2836L18.175 13.6836H6V11.6836H18.175L14.6 8.08359L16 6.68359L22 12.6836L16 18.6836Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ComponentConfigSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.67578 12.4688V6.46875H3.67578V2.46875C3.67578 2.18542 3.77161 1.94792 3.96328 1.75625C4.15495 1.56458 4.39245 1.46875 4.67578 1.46875C4.95911 1.46875 5.19661 1.56458 5.38828 1.75625C5.57995 1.94792 5.67578 2.18542 5.67578 2.46875V6.46875H7.67578V12.4688H1.67578ZM3.67578 23.4688V19.2688C3.09245 19.0688 2.61328 18.7146 2.23828 18.2063C1.86328 17.6979 1.67578 17.1188 1.67578 16.4688V14.4688H7.67578V16.4688C7.67578 17.1188 7.48828 17.6979 7.11328 18.2063C6.73828 18.7146 6.25911 19.0688 5.67578 19.2688V23.4688H3.67578ZM9.67578 12.4688V6.46875H11.6758V2.46875C11.6758 2.18542 11.7716 1.94792 11.9633 1.75625C12.1549 1.56458 12.3924 1.46875 12.6758 1.46875C12.9591 1.46875 13.1966 1.56458 13.3883 1.75625C13.5799 1.94792 13.6758 2.18542 13.6758 2.46875V6.46875H15.6758V12.4688H9.67578ZM11.6758 23.4688V19.2688C11.0924 19.0688 10.6133 18.7146 10.2383 18.2063C9.86328 17.6979 9.67578 17.1188 9.67578 16.4688V14.4688H15.6758V16.4688C15.6758 17.1188 15.4883 17.6979 15.1133 18.2063C14.7383 18.7146 14.2591 19.0688 13.6758 19.2688V23.4688H11.6758ZM17.6758 12.4688V6.46875H19.6758V2.46875C19.6758 2.18542 19.7716 1.94792 19.9633 1.75625C20.1549 1.56458 20.3924 1.46875 20.6758 1.46875C20.9591 1.46875 21.1966 1.56458 21.3883 1.75625C21.5799 1.94792 21.6758 2.18542 21.6758 2.46875V6.46875H23.6758V12.4688H17.6758ZM19.6758 23.4688V19.2688C19.0924 19.0688 18.6133 18.7146 18.2383 18.2063C17.8633 17.6979 17.6758 17.1188 17.6758 16.4688V14.4688H23.6758V16.4688C23.6758 17.1188 23.4883 17.6979 23.1133 18.2063C22.7383 18.7146 22.2591 19.0688 21.6758 19.2688V23.4688H19.6758Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function UbicationSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="21"
        viewBox="0 0 17 21"
        width="17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.87695 10.9688C9.42695 10.9688 9.89779 10.7729 10.2895 10.3813C10.6811 9.98958 10.877 9.51875 10.877 8.96875C10.877 8.41875 10.6811 7.94792 10.2895 7.55625C9.89779 7.16458 9.42695 6.96875 8.87695 6.96875C8.32695 6.96875 7.85612 7.16458 7.46445 7.55625C7.07279 7.94792 6.87695 8.41875 6.87695 8.96875C6.87695 9.51875 7.07279 9.98958 7.46445 10.3813C7.85612 10.7729 8.32695 10.9688 8.87695 10.9688ZM8.87695 20.9688C6.19362 18.6854 4.18945 16.5646 2.86445 14.6062C1.53945 12.6479 0.876953 10.8354 0.876953 9.16875C0.876953 6.66875 1.68112 4.67708 3.28945 3.19375C4.89779 1.71042 6.76029 0.96875 8.87695 0.96875C10.9936 0.96875 12.8561 1.71042 14.4645 3.19375C16.0728 4.67708 16.877 6.66875 16.877 9.16875C16.877 10.8354 16.2145 12.6479 14.8895 14.6062C13.5645 16.5646 11.5603 18.6854 8.87695 20.9688Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function MasiveLoadSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.877 19.4688H13.877V15.2937L15.477 16.8938L16.877 15.4688L12.877 11.4688L8.87695 15.4688L10.302 16.8688L11.877 15.2937V19.4688ZM6.87695 22.4688C6.32695 22.4688 5.85612 22.2729 5.46445 21.8813C5.07279 21.4896 4.87695 21.0188 4.87695 20.4688V4.46875C4.87695 3.91875 5.07279 3.44792 5.46445 3.05625C5.85612 2.66458 6.32695 2.46875 6.87695 2.46875H14.877L20.877 8.46875V20.4688C20.877 21.0188 20.6811 21.4896 20.2895 21.8813C19.8978 22.2729 19.427 22.4688 18.877 22.4688H6.87695ZM13.877 9.46875H18.877L13.877 4.46875V9.46875Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function SuppliesSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.87695 21.9688C5.77695 21.9688 4.83529 21.5771 4.05195 20.7938C3.26862 20.0104 2.87695 19.0688 2.87695 17.9688C2.87695 16.8688 3.26862 15.9271 4.05195 15.1438C4.83529 14.3604 5.77695 13.9688 6.87695 13.9688C7.97695 13.9688 8.91862 14.3604 9.70195 15.1438C10.4853 15.9271 10.877 16.8688 10.877 17.9688C10.877 19.0688 10.4853 20.0104 9.70195 20.7938C8.91862 21.5771 7.97695 21.9688 6.87695 21.9688ZM18.877 21.9688C17.777 21.9688 16.8353 21.5771 16.052 20.7938C15.2686 20.0104 14.877 19.0688 14.877 17.9688C14.877 16.8688 15.2686 15.9271 16.052 15.1438C16.8353 14.3604 17.777 13.9688 18.877 13.9688C19.977 13.9688 20.9186 14.3604 21.702 15.1438C22.4853 15.9271 22.877 16.8688 22.877 17.9688C22.877 19.0688 22.4853 20.0104 21.702 20.7938C20.9186 21.5771 19.977 21.9688 18.877 21.9688ZM12.877 15.8688C12.3436 15.8688 11.8936 15.6854 11.527 15.3188C11.1603 14.9521 10.977 14.5021 10.977 13.9688C10.977 13.4354 11.1603 12.9854 11.527 12.6188C11.8936 12.2521 12.3436 12.0688 12.877 12.0688C13.4103 12.0688 13.8603 12.2521 14.227 12.6188C14.5936 12.9854 14.777 13.4354 14.777 13.9688C14.777 14.5021 14.5936 14.9521 14.227 15.3188C13.8603 15.6854 13.4103 15.8688 12.877 15.8688ZM12.877 10.9688C11.777 10.9688 10.8353 10.5771 10.052 9.79375C9.26862 9.01042 8.87695 8.06875 8.87695 6.96875C8.87695 5.86875 9.26862 4.92708 10.052 4.14375C10.8353 3.36042 11.777 2.96875 12.877 2.96875C13.977 2.96875 14.9186 3.36042 15.702 4.14375C16.4853 4.92708 16.877 5.86875 16.877 6.96875C16.877 8.06875 16.4853 9.01042 15.702 9.79375C14.9186 10.5771 13.977 10.9688 12.877 10.9688Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function AssetManagementITSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.16797 20.4688V18.4688H5.91797L5.51797 18.1188C4.6513 17.3521 4.04297 16.4771 3.69297 15.4938C3.34297 14.5104 3.16797 13.5188 3.16797 12.5188C3.16797 10.6688 3.72214 9.02292 4.83047 7.58125C5.9388 6.13958 7.38464 5.18542 9.16797 4.71875V6.81875C7.96797 7.25208 7.0013 7.98958 6.26797 9.03125C5.53464 10.0729 5.16797 11.2354 5.16797 12.5188C5.16797 13.2688 5.30964 13.9979 5.59297 14.7063C5.8763 15.4146 6.31797 16.0688 6.91797 16.6687L7.16797 16.9187V14.4688H9.16797V20.4688H3.16797ZM21.093 11.4688H19.068C18.9846 10.8854 18.8055 10.3271 18.5305 9.79375C18.2555 9.26042 17.8846 8.75208 17.418 8.26875L17.168 8.01875V10.4688H15.168V4.46875H21.168V6.46875H18.418L18.818 6.81875C19.5013 7.51875 20.0263 8.26042 20.393 9.04375C20.7596 9.82708 20.993 10.6354 21.093 11.4688ZM17.168 23.4688L16.868 21.9688C16.668 21.8854 16.4805 21.7979 16.3055 21.7063C16.1305 21.6146 15.9513 21.5021 15.768 21.3687L14.318 21.8188L13.318 20.1188L14.468 19.1188C14.4346 18.8854 14.418 18.6687 14.418 18.4688C14.418 18.2688 14.4346 18.0521 14.468 17.8188L13.318 16.8188L14.318 15.1188L15.768 15.5688C15.9513 15.4354 16.1305 15.3229 16.3055 15.2312C16.4805 15.1396 16.668 15.0521 16.868 14.9688L17.168 13.4688H19.168L19.468 14.9688C19.668 15.0521 19.8555 15.1438 20.0305 15.2438C20.2055 15.3438 20.3846 15.4688 20.568 15.6188L22.018 15.1188L23.018 16.8688L21.868 17.8688C21.9013 18.0688 21.918 18.2771 21.918 18.4938C21.918 18.7104 21.9013 18.9187 21.868 19.1188L23.018 20.1188L22.018 21.8188L20.568 21.3687C20.3846 21.5021 20.2055 21.6146 20.0305 21.7063C19.8555 21.7979 19.668 21.8854 19.468 21.9688L19.168 23.4688H17.168ZM18.168 20.4688C18.718 20.4688 19.1888 20.2729 19.5805 19.8813C19.9721 19.4896 20.168 19.0188 20.168 18.4688C20.168 17.9187 19.9721 17.4479 19.5805 17.0563C19.1888 16.6646 18.718 16.4688 18.168 16.4688C17.618 16.4688 17.1471 16.6646 16.7555 17.0563C16.3638 17.4479 16.168 17.9187 16.168 18.4688C16.168 19.0188 16.3638 19.4896 16.7555 19.8813C17.1471 20.2729 17.618 20.4688 18.168 20.4688Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function WarehouseITSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6979 11.9844L8.04785 6.33437L13.6979 0.684372L19.3479 6.33437L13.6979 11.9844ZM0.0478516 9.98437V1.98437H8.04785V9.98437H0.0478516ZM10.0479 19.9844V11.9844H18.0479V19.9844H10.0479ZM0.0478516 19.9844V11.9844H8.04785V19.9844H0.0478516Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function EnginnerITSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.15063 21.9844V19.1844C1.15063 18.6344 1.2923 18.1177 1.57563 17.6344C1.85897 17.151 2.25063 16.7844 2.75063 16.5344C3.60063 16.101 4.55897 15.7344 5.62563 15.4344C6.6923 15.1344 7.8673 14.9844 9.15063 14.9844C10.434 14.9844 11.609 15.1344 12.6756 15.4344C13.7423 15.7344 14.7006 16.101 15.5506 16.5344C16.0506 16.7844 16.4423 17.151 16.7256 17.6344C17.009 18.1177 17.1506 18.6344 17.1506 19.1844V21.9844H1.15063ZM9.15063 13.9844C8.05063 13.9844 7.10897 13.5927 6.32563 12.8094C5.5423 12.026 5.15063 11.0844 5.15063 9.98438H4.90063C4.75063 9.98438 4.6298 9.93854 4.53813 9.84688C4.44647 9.75521 4.40063 9.63438 4.40063 9.48438C4.40063 9.33437 4.44647 9.21354 4.53813 9.12188C4.6298 9.03021 4.75063 8.98438 4.90063 8.98438H5.15063C5.15063 8.23438 5.33397 7.55938 5.70063 6.95938C6.0673 6.35938 6.55063 5.88437 7.15063 5.53438V6.48438C7.15063 6.63438 7.19647 6.75521 7.28814 6.84687C7.3798 6.93854 7.50063 6.98438 7.65063 6.98438C7.80063 6.98438 7.92147 6.93854 8.01313 6.84687C8.1048 6.75521 8.15063 6.63438 8.15063 6.48438V5.13437C8.30063 5.08438 8.45897 5.04688 8.62563 5.02188C8.7923 4.99688 8.9673 4.98438 9.15063 4.98438C9.33397 4.98438 9.50897 4.99688 9.67564 5.02188C9.8423 5.04688 10.0006 5.08438 10.1506 5.13437V6.48438C10.1506 6.63438 10.1965 6.75521 10.2881 6.84687C10.3798 6.93854 10.5006 6.98438 10.6506 6.98438C10.8006 6.98438 10.9215 6.93854 11.0131 6.84687C11.1048 6.75521 11.1506 6.63438 11.1506 6.48438V5.53438C11.7506 5.88437 12.234 6.35938 12.6006 6.95938C12.9673 7.55938 13.1506 8.23438 13.1506 8.98438H13.4006C13.5506 8.98438 13.6715 9.03021 13.7631 9.12188C13.8548 9.21354 13.9006 9.33437 13.9006 9.48438C13.9006 9.63438 13.8548 9.75521 13.7631 9.84688C13.6715 9.93854 13.5506 9.98438 13.4006 9.98438H13.1506C13.1506 11.0844 12.759 12.026 11.9756 12.8094C11.1923 13.5927 10.2506 13.9844 9.15063 13.9844ZM9.15063 11.9844C9.70063 11.9844 10.1715 11.7885 10.5631 11.3969C10.9548 11.0052 11.1506 10.5344 11.1506 9.98438H7.15063C7.15063 10.5344 7.34647 11.0052 7.73813 11.3969C8.1298 11.7885 8.60064 11.9844 9.15063 11.9844ZM16.6506 15.9844L16.5006 15.2344C16.4006 15.201 16.3048 15.1635 16.2131 15.1219C16.1215 15.0802 16.034 15.0177 15.9506 14.9344L15.2506 15.1844L14.7506 14.2844L15.3006 13.7844V13.1844L14.7506 12.6844L15.2506 11.7844L15.9506 12.0344C16.0173 11.9677 16.1006 11.9094 16.2006 11.8594C16.3006 11.8094 16.4006 11.7677 16.5006 11.7344L16.6506 10.9844H17.6506L17.8006 11.7344C17.9006 11.7677 18.0006 11.8094 18.1006 11.8594C18.2006 11.9094 18.284 11.9677 18.3506 12.0344L19.0506 11.7844L19.5506 12.6844L19.0006 13.1844V13.7844L19.5506 14.2844L19.0506 15.1844L18.3506 14.9344C18.2673 15.0177 18.1798 15.0802 18.0881 15.1219C17.9965 15.1635 17.9006 15.201 17.8006 15.2344L17.6506 15.9844H16.6506ZM17.1506 14.2344C17.3506 14.2344 17.5256 14.1594 17.6756 14.0094C17.8256 13.8594 17.9006 13.6844 17.9006 13.4844C17.9006 13.2844 17.8256 13.1094 17.6756 12.9594C17.5256 12.8094 17.3506 12.7344 17.1506 12.7344C16.9506 12.7344 16.7756 12.8094 16.6256 12.9594C16.4756 13.1094 16.4006 13.2844 16.4006 13.4844C16.4006 13.6844 16.4756 13.8594 16.6256 14.0094C16.7756 14.1594 16.9506 14.2344 17.1506 14.2344ZM18.9506 10.9844L18.7506 9.93438C18.6006 9.88438 18.4631 9.82188 18.3381 9.74688C18.2131 9.67188 18.1006 9.58437 18.0006 9.48438L16.9506 9.83437L16.2506 8.63438L17.1006 7.88438C17.0673 7.80104 17.0506 7.73438 17.0506 7.68438V7.28437C17.0506 7.23438 17.0673 7.16771 17.1006 7.08438L16.2506 6.33438L16.9506 5.13437L18.0006 5.48438C18.1006 5.38437 18.2131 5.29688 18.3381 5.22188C18.4631 5.14688 18.6006 5.08438 18.7506 5.03438L18.9506 3.98438H20.3506L20.5506 5.03438C20.7006 5.08438 20.8381 5.14688 20.9631 5.22188C21.0881 5.29688 21.2006 5.38437 21.3006 5.48438L22.3506 5.13437L23.0506 6.33438L22.2006 7.08438C22.234 7.16771 22.2506 7.23438 22.2506 7.28437V7.68438C22.2506 7.73438 22.234 7.80104 22.2006 7.88438L23.0506 8.63438L22.3506 9.83437L21.3006 9.48438C21.2006 9.58437 21.0881 9.67188 20.9631 9.74688C20.8381 9.82188 20.7006 9.88438 20.5506 9.93438L20.3506 10.9844H18.9506ZM19.6506 8.73438C20.0006 8.73438 20.2965 8.61354 20.5381 8.37188C20.7798 8.13021 20.9006 7.83438 20.9006 7.48438C20.9006 7.13438 20.7798 6.83854 20.5381 6.59687C20.2965 6.35521 20.0006 6.23438 19.6506 6.23438C19.3006 6.23438 19.0048 6.35521 18.7631 6.59687C18.5215 6.83854 18.4006 7.13438 18.4006 7.48438C18.4006 7.83438 18.5215 8.13021 18.7631 8.37188C19.0048 8.61354 19.3006 8.73438 19.6506 8.73438Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function EnablingServiceFlowSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_674_38065)">
          <path
            clip-rule="evenodd"
            d="M8.76689 13.1188C8.46946 15.0341 6.81315 16.5 4.81445 16.5C2.60531 16.5 0.814453 14.7091 0.814453 12.5C0.814453 10.2909 2.60531 8.5 4.81445 8.5C6.53812 8.5 8.00715 9.59024 8.56956 11.1188H17.0593C17.6218 9.59024 19.0908 8.5 20.8145 8.5C23.0236 8.5 24.8145 10.2909 24.8145 12.5C24.8145 14.7091 23.0236 16.5 20.8145 16.5C18.8158 16.5 17.1594 15.0341 16.862 13.1188H8.76689Z"
            fill="#3352C1"
            fill-rule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="clip0_674_38065">
            <rect
              fill="white"
              height="24"
              transform="translate(0.814453 0.5)"
              width="24"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function ServiceExpirationsSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3145 11.75C13.4145 11.75 14.3561 11.3583 15.1395 10.575C15.9228 9.79167 16.3145 8.85 16.3145 7.75V4.75H8.31445V7.75C8.31445 8.85 8.70612 9.79167 9.48945 10.575C10.2728 11.3583 11.2145 11.75 12.3145 11.75ZM4.31445 22.75V20.75H6.31445V17.75C6.31445 16.7333 6.55195 15.7792 7.02695 14.8875C7.50195 13.9958 8.16445 13.2833 9.01445 12.75C8.16445 12.2167 7.50195 11.5042 7.02695 10.6125C6.55195 9.72083 6.31445 8.76667 6.31445 7.75V4.75H4.31445V2.75H20.3145V4.75H18.3145V7.75C18.3145 8.76667 18.077 9.72083 17.602 10.6125C17.127 11.5042 16.4645 12.2167 15.6145 12.75C16.4645 13.2833 17.127 13.9958 17.602 14.8875C18.077 15.7792 18.3145 16.7333 18.3145 17.75V20.75H20.3145V22.75H4.31445Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServiceNotificationSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.31445 19.75V17.75H6.31445V10.75C6.31445 9.36667 6.73112 8.1375 7.56445 7.0625C8.39779 5.9875 9.48112 5.28333 10.8145 4.95V4.25C10.8145 3.83333 10.9603 3.47917 11.252 3.1875C11.5436 2.89583 11.8978 2.75 12.3145 2.75C12.7311 2.75 13.0853 2.89583 13.377 3.1875C13.6686 3.47917 13.8145 3.83333 13.8145 4.25V4.95C15.1478 5.28333 16.2311 5.9875 17.0645 7.0625C17.8978 8.1375 18.3145 9.36667 18.3145 10.75V17.75H20.3145V19.75H4.31445ZM12.3145 22.75C11.7645 22.75 11.2936 22.5542 10.902 22.1625C10.5103 21.7708 10.3145 21.3 10.3145 20.75H14.3145C14.3145 21.3 14.1186 21.7708 13.727 22.1625C13.3353 22.5542 12.8645 22.75 12.3145 22.75Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServiceBehaviorSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3145 19.75C15.8645 19.75 15.427 19.7083 15.002 19.625C14.577 19.5417 14.1645 19.425 13.7645 19.275C14.7311 18.4583 15.4811 17.4833 16.0145 16.35C16.5478 15.2167 16.8145 14.0167 16.8145 12.75C16.8145 11.4833 16.5478 10.2833 16.0145 9.15C15.4811 8.01667 14.7311 7.04167 13.7645 6.225C14.1645 6.075 14.577 5.95833 15.002 5.875C15.427 5.79167 15.8645 5.75 16.3145 5.75C18.2645 5.75 19.9186 6.42917 21.277 7.7875C22.6353 9.14583 23.3145 10.8 23.3145 12.75C23.3145 14.7 22.6353 16.3542 21.277 17.7125C19.9186 19.0708 18.2645 19.75 16.3145 19.75ZM8.31445 19.75C6.36445 19.75 4.71029 19.0708 3.35195 17.7125C1.99362 16.3542 1.31445 14.7 1.31445 12.75C1.31445 10.8 1.99362 9.14583 3.35195 7.7875C4.71029 6.42917 6.36445 5.75 8.31445 5.75C8.76445 5.75 9.20195 5.79167 9.62695 5.875C10.052 5.95833 10.4645 6.075 10.8645 6.225C10.5811 6.45833 10.3145 6.7125 10.0645 6.9875C9.81445 7.2625 9.58112 7.55 9.36445 7.85C9.19779 7.81667 9.02695 7.79167 8.85195 7.775C8.67695 7.75833 8.49779 7.75 8.31445 7.75C6.93112 7.75 5.75195 8.2375 4.77695 9.2125C3.80195 10.1875 3.31445 11.3667 3.31445 12.75C3.31445 14.1333 3.80195 15.3125 4.77695 16.2875C5.75195 17.2625 6.93112 17.75 8.31445 17.75C8.49779 17.75 8.67695 17.7417 8.85195 17.725C9.02695 17.7083 9.19779 17.6833 9.36445 17.65C9.58112 17.95 9.81445 18.2375 10.0645 18.5125C10.3145 18.7875 10.5811 19.0417 10.8645 19.275C10.4645 19.425 10.052 19.5417 9.62695 19.625C9.20195 19.7083 8.76445 19.75 8.31445 19.75ZM12.3145 18.5C11.3645 17.85 10.627 17.0167 10.102 16C9.57695 14.9833 9.31445 13.9 9.31445 12.75C9.31445 11.6 9.57695 10.5167 10.102 9.5C10.627 8.48333 11.3645 7.65 12.3145 7C13.2645 7.65 14.002 8.48333 14.527 9.5C15.052 10.5167 15.3145 11.6 15.3145 12.75C15.3145 13.9 15.052 14.9833 14.527 16C14.002 17.0167 13.2645 17.85 12.3145 18.5Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServiceConsumableMovementsSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.3145 21.75V19.75H13.3145V21.75H11.3145ZM11.3145 5.75V3.75H13.3145V5.75H11.3145ZM15.3145 21.75V19.75H17.3145V21.75H15.3145ZM15.3145 5.75V3.75H17.3145V5.75H15.3145ZM19.3145 21.75V19.75H21.3145V21.75H19.3145ZM19.3145 5.75V3.75H21.3145V5.75H19.3145ZM17.3145 16.75L15.9145 15.35L17.4895 13.75H11.3145V11.75H17.4895L15.9145 10.15L17.3145 8.75L21.3145 12.75L17.3145 16.75ZM3.31445 21.75V3.75H9.31445V21.75H3.31445Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServiceAtentionHourSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9645 21.1L20.6645 20.4L18.8145 18.55V15.75H17.8145V18.95L19.9645 21.1ZM10.3145 6.75H14.3145V4.75H10.3145V6.75ZM18.3145 23.75C16.9311 23.75 15.752 23.2625 14.777 22.2875C13.802 21.3125 13.3145 20.1333 13.3145 18.75C13.3145 17.3667 13.802 16.1875 14.777 15.2125C15.752 14.2375 16.9311 13.75 18.3145 13.75C19.6978 13.75 20.877 14.2375 21.852 15.2125C22.827 16.1875 23.3145 17.3667 23.3145 18.75C23.3145 20.1333 22.827 21.3125 21.852 22.2875C20.877 23.2625 19.6978 23.75 18.3145 23.75ZM4.31445 21.75C3.76445 21.75 3.29362 21.5542 2.90195 21.1625C2.51029 20.7708 2.31445 20.3 2.31445 19.75V8.75C2.31445 8.2 2.51029 7.72917 2.90195 7.3375C3.29362 6.94583 3.76445 6.75 4.31445 6.75H8.31445V4.75C8.31445 4.2 8.51029 3.72917 8.90195 3.3375C9.29362 2.94583 9.76445 2.75 10.3145 2.75H14.3145C14.8645 2.75 15.3353 2.94583 15.727 3.3375C16.1186 3.72917 16.3145 4.2 16.3145 4.75V6.75H20.3145C20.8645 6.75 21.3353 6.94583 21.727 7.3375C22.1186 7.72917 22.3145 8.2 22.3145 8.75V13.025C21.7311 12.6083 21.0978 12.2917 20.4145 12.075C19.7311 11.8583 19.0311 11.75 18.3145 11.75C16.3811 11.75 14.7311 12.4333 13.3645 13.8C11.9978 15.1667 11.3145 16.8167 11.3145 18.75C11.3145 19.2667 11.3686 19.7792 11.477 20.2875C11.5853 20.7958 11.7561 21.2833 11.9895 21.75H4.31445Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function ServiceConfigurationSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.56367 22.75L9.16367 19.55C8.94701 19.4667 8.74284 19.3667 8.55117 19.25C8.35951 19.1333 8.17201 19.0083 7.98867 18.875L5.01367 20.125L2.26367 15.375L4.83867 13.425C4.82201 13.3083 4.81367 13.1958 4.81367 13.0875V12.4125C4.81367 12.3042 4.82201 12.1917 4.83867 12.075L2.26367 10.125L5.01367 5.375L7.98867 6.625C8.17201 6.49167 8.36367 6.36667 8.56367 6.25C8.76367 6.13333 8.96367 6.03333 9.16367 5.95L9.56367 2.75H15.0637L15.4637 5.95C15.6803 6.03333 15.8845 6.13333 16.0762 6.25C16.2678 6.36667 16.4553 6.49167 16.6387 6.625L19.6137 5.375L22.3637 10.125L19.7887 12.075C19.8053 12.1917 19.8137 12.3042 19.8137 12.4125V13.0875C19.8137 13.1958 19.797 13.3083 19.7637 13.425L22.3387 15.375L19.5887 20.125L16.6387 18.875C16.4553 19.0083 16.2637 19.1333 16.0637 19.25C15.8637 19.3667 15.6637 19.4667 15.4637 19.55L15.0637 22.75H9.56367ZM12.3637 16.25C13.3303 16.25 14.1553 15.9083 14.8387 15.225C15.522 14.5417 15.8637 13.7167 15.8637 12.75C15.8637 11.7833 15.522 10.9583 14.8387 10.275C14.1553 9.59167 13.3303 9.25 12.3637 9.25C11.3803 9.25 10.5512 9.59167 9.87617 10.275C9.20117 10.9583 8.86367 11.7833 8.86367 12.75C8.86367 13.7167 9.20117 14.5417 9.87617 15.225C10.5512 15.9083 11.3803 16.25 12.3637 16.25Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function LikeButtonSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#F45252" height="24" rx="2" width="24" x="0.385742" />
        <path
          d="M7.92305 5.25H16.248V14.85L11.0355 20.25L10.3043 19.6688C10.2293 19.6063 10.173 19.5188 10.1355 19.4063C10.098 19.2938 10.0793 19.1563 10.0793 18.9938V18.8063L10.923 14.85H5.3168C5.0168 14.85 4.7543 14.7375 4.5293 14.5125C4.3043 14.2875 4.1918 14.025 4.1918 13.725V12.1905C4.1918 12.101 4.18242 12.0094 4.16367 11.9156C4.14492 11.8219 4.1543 11.7313 4.1918 11.6438L6.5543 6.20625C6.66527 5.94063 6.85024 5.71484 7.1092 5.52891C7.36815 5.34297 7.63943 5.25 7.92305 5.25ZM15.123 6.375H7.6793L5.3168 11.9813V13.725H12.3105L11.3168 18.3938L15.123 14.3813V6.375ZM16.248 14.85V13.725H18.7418V6.375H16.248V5.25H19.8668V14.85H16.248Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function RejectButtonSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#0D45B0" height="24" rx="2" width="24" x="0.706055" />
        <path
          d="M17.1313 18.75H8.80625V9.15L14.0188 3.75L14.75 4.33125C14.825 4.39375 14.8813 4.48125 14.9188 4.59375C14.9563 4.70625 14.975 4.84375 14.975 5.00625V5.19375L14.1313 9.15H19.7375C20.0375 9.15 20.3 9.2625 20.525 9.4875C20.75 9.7125 20.8625 9.975 20.8625 10.275V11.8095C20.8625 11.899 20.8719 11.9906 20.8906 12.0844C20.9094 12.1781 20.9 12.2688 20.8625 12.3563L18.5 17.7938C18.389 18.0594 18.2041 18.2852 17.9451 18.4711C17.6861 18.657 17.4149 18.75 17.1313 18.75ZM9.93125 17.625H17.375L19.7375 12.0188V10.275H12.7438L13.7375 5.60625L9.93125 9.61875V17.625ZM8.80625 9.15V10.275H6.3125V17.625H8.80625V18.75H5.1875V9.15H8.80625Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function ReasignToAnotherIng(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_617_15135)">
          <path
            d="M13.3809 12.8074C13.8642 12.2741 14.235 11.6658 14.4934 10.9824C14.7517 10.2991 14.8809 9.59076 14.8809 8.85742C14.8809 8.12409 14.7517 7.41576 14.4934 6.73242C14.235 6.04909 13.8642 5.44076 13.3809 4.90742C14.3809 5.04076 15.2142 5.48242 15.8809 6.23242C16.5475 6.98242 16.8809 7.85742 16.8809 8.85742C16.8809 9.85742 16.5475 10.7324 15.8809 11.4824C15.2142 12.2324 14.3809 12.6741 13.3809 12.8074ZM18.8809 20.8574V17.8574C18.8809 17.2574 18.7475 16.6866 18.4809 16.1449C18.2142 15.6033 17.8642 15.1241 17.4309 14.7074C18.2809 15.0074 19.0684 15.3949 19.7934 15.8699C20.5184 16.3449 20.8809 17.0074 20.8809 17.8574V20.8574H18.8809ZM20.8809 13.8574V11.8574H18.8809V9.85742H20.8809V7.85742H22.8809V9.85742H24.8809V11.8574H22.8809V13.8574H20.8809ZM8.88086 12.8574C7.78086 12.8574 6.83919 12.4658 6.05586 11.6824C5.27253 10.8991 4.88086 9.95742 4.88086 8.85742C4.88086 7.75742 5.27253 6.81576 6.05586 6.03242C6.83919 5.24909 7.78086 4.85742 8.88086 4.85742C9.98086 4.85742 10.9225 5.24909 11.7059 6.03242C12.4892 6.81576 12.8809 7.75742 12.8809 8.85742C12.8809 9.95742 12.4892 10.8991 11.7059 11.6824C10.9225 12.4658 9.98086 12.8574 8.88086 12.8574ZM0.880859 20.8574V18.0574C0.880859 17.4908 1.02669 16.9699 1.31836 16.4949C1.61003 16.0199 1.99753 15.6574 2.48086 15.4074C3.51419 14.8908 4.56419 14.5033 5.63086 14.2449C6.69753 13.9866 7.78086 13.8574 8.88086 13.8574C9.98086 13.8574 11.0642 13.9866 12.1309 14.2449C13.1975 14.5033 14.2475 14.8908 15.2809 15.4074C15.7642 15.6574 16.1517 16.0199 16.4434 16.4949C16.735 16.9699 16.8809 17.4908 16.8809 18.0574V20.8574H0.880859Z"
            fill="#626262"
          />
        </g>
        <defs>
          <clipPath id="clip0_617_15135">
            <rect
              fill="white"
              height="24"
              transform="translate(0.880859 0.857422)"
              width="24"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function InformativeModuleSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.20117 21.2344C4.65117 21.2344 4.18034 21.0385 3.78867 20.6469C3.39701 20.2552 3.20117 19.7844 3.20117 19.2344V5.23438C3.20117 4.68438 3.39701 4.21354 3.78867 3.82188C4.18034 3.43021 4.65117 3.23438 5.20117 3.23438H19.2012C19.7512 3.23438 20.222 3.43021 20.6137 3.82188C21.0053 4.21354 21.2012 4.68438 21.2012 5.23438V19.2344C21.2012 19.7844 21.0053 20.2552 20.6137 20.6469C20.222 21.0385 19.7512 21.2344 19.2012 21.2344H5.20117ZM5.20117 19.2344H19.2012V7.23438H5.20117V19.2344ZM7.20117 12.2344V10.2344H17.2012V12.2344H7.20117ZM7.20117 16.2344V14.2344H13.2012V16.2344H7.20117Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

export function ClosingTemplate(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="25"
        viewBox="0 0 25 25"
        width="25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 21.7656C4.95 21.7656 4.47917 21.5698 4.0875 21.1781C3.69583 20.7865 3.5 20.3156 3.5 19.7656V5.76562C3.5 5.21563 3.69583 4.74479 4.0875 4.35313C4.47917 3.96146 4.95 3.76562 5.5 3.76562H14.5V5.76562H5.5V19.7656H19.5V10.7656H21.5V19.7656C21.5 20.3156 21.3042 20.7865 20.9125 21.1781C20.5208 21.5698 20.05 21.7656 19.5 21.7656H5.5ZM8.5 17.7656V15.7656H16.5V17.7656H8.5ZM8.5 14.7656V12.7656H16.5V14.7656H8.5ZM8.5 11.7656V9.76562H16.5V11.7656H8.5ZM17.5 9.76562V7.76562H15.5V5.76562H17.5V3.76562H19.5V5.76562H21.5V7.76562H19.5V9.76562H17.5Z"
          fill="#737373"
        />
      </svg>
    </SvgIcon>
  );
}

export function EmptyScreenIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="244"
        viewBox="0 0 222 244"
        width="222"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1144_533)">
          <path
            d="M110.625 0C111.972 1.07422 113.467 2.00998 114.646 3.24652C131.064 20.4101 147.424 37.6262 163.842 54.7946C165.594 56.6279 166.435 58.6284 166.425 61.1826C166.363 75.0806 166.396 88.9786 166.396 102.877V105.221C171.305 106.982 176.167 108.286 180.632 110.406C203.587 121.301 217.588 139.228 221.274 164.47C226.226 198.386 205.416 230.78 172.69 240.882C142.844 250.097 110.439 238.352 93.4867 212.089C92.4982 210.556 91.4763 210.026 89.676 210.031C69.3379 210.098 48.995 210.088 28.6569 210.069C15.7206 210.06 5.45364 203.218 1.62383 191.779C0.635342 188.823 0.081404 185.572 0.0766287 182.455C-0.0141025 130.921 -0.0141025 79.3775 0.0288754 27.8294C0.0384261 13.7929 9.22137 2.96006 23.0125 0.386718C23.3086 0.334201 23.5712 0.13368 23.8482 0C52.7723 0 81.7012 0 110.625 0ZM96.1561 131.78C94.7856 131.78 93.8687 131.78 92.9519 131.78C76.3433 131.78 59.7347 131.78 43.1262 131.78C38.4989 131.78 36.2067 130.128 36.1446 126.796C36.0826 123.373 38.4798 121.582 43.1548 121.582C63.2589 121.582 83.363 121.611 103.467 121.52C104.828 121.515 106.433 120.952 107.498 120.107C117.406 112.253 128.495 107.03 141.011 105.125C145.925 104.38 150.934 104.275 156.077 103.865V64.6153C155.117 64.6153 154.267 64.6153 153.422 64.6153C145.156 64.6153 136.894 64.6726 128.628 64.5819C126.183 64.5533 123.657 64.4387 121.317 63.8085C110.683 60.9439 104.437 52.6128 104.355 41.3454C104.289 31.8923 104.341 22.4392 104.341 12.9861C104.341 12.1363 104.341 11.2864 104.341 10.3029C103.386 10.2361 102.694 10.1454 102.001 10.1454C77.5276 10.1358 53.0493 10.1263 28.5758 10.1693C26.6895 10.1693 24.7412 10.3698 22.9361 10.8711C14.7178 13.1675 10.1526 19.6558 10.1478 28.9848C10.1335 79.7403 10.1335 130.501 10.1669 181.256C10.1669 183.147 10.3101 185.095 10.7829 186.909C12.9366 195.192 19.3594 199.862 28.7047 199.89C47.381 199.943 66.0525 199.909 84.7288 199.9C85.3925 199.9 86.0563 199.78 86.9732 199.69C84.3372 192.791 82.8425 185.949 82.2934 178.859C81.7442 171.784 82.4844 164.833 83.9456 157.733H81.0757C68.359 157.733 55.6471 157.743 42.9304 157.719C41.8321 157.719 40.6955 157.638 39.6402 157.347C37.3337 156.712 36.0157 154.702 36.1494 152.31C36.2831 149.98 37.9067 148.123 40.2562 147.75C41.2686 147.588 42.3144 147.574 43.3411 147.574C57.2468 147.564 71.1525 147.54 85.0583 147.602C86.7249 147.612 87.5176 147.072 88.2864 145.568C90.23 141.758 92.4648 138.101 94.5898 134.387C95.0053 133.656 95.4542 132.945 96.1466 131.78H96.1561ZM152.004 233.917C184.748 234.084 211.623 207.29 211.814 174.281C212.005 141.486 185.283 114.597 152.295 114.392C119.412 114.187 92.4075 141.09 92.3502 174.109C92.2929 206.928 119.044 233.75 152.004 233.917ZM114.517 17.8893C114.517 26.6644 114.288 34.7521 114.589 42.8207C114.837 49.5095 120.071 54.2121 126.766 54.3649C130.099 54.4413 133.432 54.384 136.765 54.384C140.696 54.384 144.626 54.384 149.196 54.384C137.491 42.0616 126.222 30.207 114.522 17.8845L114.517 17.8893Z"
            fill="#9E9E9E"
          />
          <path
            d="M66.9075 96.1784C75.4028 96.1784 83.8981 96.1306 92.3934 96.2022C95.5069 96.2309 97.6892 98.4032 97.7178 101.163C97.7465 103.927 95.5737 106.052 92.4841 106.266C91.8537 106.309 91.2139 106.281 90.5787 106.281C79.0654 106.281 67.5569 106.281 56.0436 106.281C51.2014 106.281 46.3592 106.3 41.5171 106.266C39.2727 106.252 37.4533 105.316 36.5507 103.211C35.7485 101.335 35.8153 99.1957 37.4485 97.9544C38.7808 96.947 40.7053 96.2738 42.3814 96.2357C50.5568 96.0638 58.7369 96.1593 66.9122 96.1593V96.1736L66.9075 96.1784Z"
            fill="#9E9E9E"
          />
          <path
            d="M146.464 153.615C140.012 160.514 133.599 167.446 127.081 174.278C126.035 175.376 124.636 176.336 123.218 176.828C121.135 177.553 119.311 176.641 118.07 174.842C116.881 173.118 116.847 171.27 117.922 169.475C118.366 168.735 118.953 168.067 119.545 167.432C128.8 157.487 138.054 147.542 147.328 137.616C150.58 134.136 153.359 134.126 156.607 137.597C166 147.628 175.374 157.678 184.757 167.718C186.352 169.423 187.484 171.261 186.534 173.715C185.817 175.567 184.504 176.699 182.513 176.985C180.292 177.305 178.74 176.15 177.346 174.646C171.405 168.239 165.455 161.836 159.52 155.429C158.942 154.804 158.416 154.126 157.418 152.932C157.347 154.498 157.28 155.324 157.28 156.15C157.275 172.908 157.28 189.666 157.261 206.423C157.261 207.603 157.17 208.815 156.884 209.952C156.334 212.119 154.324 213.537 152.108 213.523C149.802 213.504 147.806 211.957 147.338 209.651C147.104 208.496 147.042 207.292 147.042 206.108C147.022 189.508 147.027 172.908 147.027 156.308C147.027 155.463 147.027 154.618 147.027 153.773L146.464 153.61V153.615Z"
            fill="#9E9E9E"
          />
        </g>
        <defs>
          <clipPath id="clip0_1144_533">
            <rect fill="white" height="244" width="222" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function WorkFlowOrderByLocation(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="157"
        viewBox="0 0 157 157"
        width="157"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1867 143.084C13.3267 143.084 10.6967 143.104 8.0667 143.084C3.2867 143.044 0.0467033 139.824 0.0467033 135.034C0.0367033 117.264 0.0267033 99.4944 0.0467033 81.7344C0.0467033 75.0644 4.7167 70.4544 11.3867 70.4544C53.9967 70.4544 96.5967 70.4544 139.207 70.4544C142.047 70.4544 143.947 69.3144 144.857 67.0744C145.807 64.7544 145.217 62.2044 143.157 60.3644C142.307 59.6044 141.267 59.0444 139.957 58.1344C139.957 59.5844 139.957 60.6144 139.957 61.6444C139.957 62.6744 139.957 63.7644 139.957 64.9444H16.2867V43.5444H18.1667C30.4467 43.5444 42.7167 43.5444 54.9967 43.5444C58.5767 43.5444 59.2467 42.8944 59.2467 39.3744C59.2467 27.0944 59.2467 14.8244 59.2467 2.54437V0.484375H61.1167C86.1167 0.484375 111.127 0.484375 136.127 0.484375C139.197 0.484375 139.967 1.27438 139.967 4.37438C139.967 21.1944 139.967 38.0044 139.967 54.8244C139.967 55.4844 139.967 56.1444 139.967 56.9844C142.667 56.9844 145.227 56.9844 147.787 56.9844C152.917 57.0044 156.107 60.1444 156.107 65.2444C156.107 82.9044 156.107 100.554 156.107 118.214C156.107 125.214 151.687 129.564 144.577 129.564C113.517 129.584 82.4567 129.604 51.4067 129.614C39.9667 129.614 28.5367 129.614 17.0967 129.634C13.3867 129.634 11.1967 131.384 10.8567 134.594C10.4967 137.924 12.6467 140.874 16.1467 141.654V135.114H139.847C139.887 135.494 139.967 135.924 139.967 136.344C139.967 141.954 139.977 147.554 139.967 153.164C139.967 155.584 139.027 156.544 136.627 156.544C97.6067 156.544 58.5867 156.544 19.5667 156.544C17.1467 156.544 16.2067 155.604 16.1867 153.194C16.1667 149.894 16.1867 146.594 16.1867 143.094V143.084ZM67.3167 99.8644C67.3167 104.284 67.2967 108.704 67.3167 113.124C67.3267 115.114 68.3367 116.144 70.2967 116.174C72.8667 116.214 75.4467 116.244 78.0167 116.154C84.4767 115.944 90.1167 111.164 91.1767 104.804C91.5667 102.454 91.5267 100.014 91.4867 97.6144C91.3667 90.9744 86.5767 85.2444 80.0167 84.2344C76.9467 83.7644 73.7767 83.9544 70.6467 83.9044C68.2467 83.8744 67.3167 84.8444 67.3067 87.2644C67.2967 91.4644 67.3067 95.6644 67.3067 99.8544L67.3167 99.8644ZM59.3767 100.154C59.3767 100.154 59.2767 100.154 59.2367 100.154C59.2367 98.5844 59.2767 97.0144 59.2367 95.4544C59.0467 88.9044 53.7167 83.8744 47.0367 83.9044C40.4767 83.9344 35.1967 89.0044 35.0467 95.4844C34.9767 98.5644 34.9667 101.644 35.0467 104.724C35.2067 110.644 39.8767 115.564 45.8067 116.144C52.0667 116.764 57.7367 112.824 58.8967 106.834C59.3167 104.654 59.2367 102.384 59.3767 100.154ZM104.987 89.2744C104.987 90.0944 104.987 90.7044 104.987 91.3144C104.987 98.5344 104.987 105.754 104.987 112.984C104.987 114.824 105.857 115.954 107.327 116.154C109.047 116.394 110.357 115.074 110.357 113.004C110.377 105.724 110.357 98.4444 110.357 91.1744C110.357 90.5844 110.357 89.9844 110.357 89.2844C113.027 89.2844 115.477 89.3044 117.937 89.2844C119.907 89.2644 121.117 88.2144 121.107 86.5944C121.107 84.9644 119.897 83.9244 117.917 83.9144C111.087 83.9044 104.257 83.9044 97.4267 83.9144C95.4367 83.9144 94.2367 84.9444 94.2267 86.5744C94.2067 88.2044 95.4067 89.2644 97.3767 89.2844C99.8367 89.3044 102.287 89.2844 104.977 89.2844L104.987 89.2744Z"
          fill="#3352C1"
        />
      </svg>
    </SvgIcon>
  );
}

export function EvidenceSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="21"
        viewBox="0 0 21 21"
        width="21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_40_3660)">
          <path
            d="M2.5352 17.6527C2.07686 17.6527 1.6845 17.4895 1.35811 17.1631C1.03172 16.8367 0.86853 16.4443 0.86853 15.986V5.15267H2.5352V15.986H16.7019V17.6527H2.5352ZM5.86853 14.3193C5.4102 14.3193 5.01784 14.1561 4.69145 13.8298C4.36506 13.5034 4.20186 13.111 4.20186 12.6527V3.486C4.20186 3.02767 4.36506 2.63531 4.69145 2.30892C5.01784 1.98253 5.4102 1.81934 5.86853 1.81934H10.0352L11.7019 3.486H17.5352C17.9935 3.486 18.3859 3.6492 18.7123 3.97559C19.0387 4.30197 19.2019 4.69434 19.2019 5.15267V12.6527C19.2019 13.111 19.0387 13.5034 18.7123 13.8298C18.3859 14.1561 17.9935 14.3193 17.5352 14.3193H5.86853ZM7.5352 10.986H15.8685L12.9935 7.236L11.0769 9.736L9.7852 8.06934L7.5352 10.986Z"
            fill="#3352C1"
          />
        </g>
        <defs>
          <clipPath id="clip0_40_3660">
            <rect
              fill="white"
              height="20"
              transform="translate(0.0351562 0.152344)"
              width="20"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function NoOperativeCheckFullSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="19"
        viewBox="0 0 19 19"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#28D74E" height="19" rx="5" width="19" />
        <path d="M5.5 10L8.5 13L15 6.5" stroke="white" />
      </svg>
    </SvgIcon>
  );
}

export function NoOperativeCheckSVG(props) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="19"
        viewBox="0 0 19 19"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#8C8C8C" height="19" rx="5" width="19" />
      </svg>
    </SvgIcon>
  );
}
